import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CultureModel} from '../../../models/localization-and-pricing/culture.model';
import {Router} from '@angular/router';
import {UserModel} from '../../../models/authentication/user.model';
import {StudentModel} from '../../../models/authentication/student.model';
import {SchoolModel} from '../../../models/school/school.model';
import {CountryModel} from '../../../models/localization-and-pricing/country.model';
import {StringExtensionModel} from '../../../models/extensions/string-extension.model';
import {NavigationModel} from '../../../models/localization-and-pricing/navigation.model';

@Component({
  selector: 'app-land2-nav-header',
  templateUrl: './land2-nav-header.component.html',
  styleUrls: ['./land2-nav-header.component.css']
})
export class Land2NavHeaderComponent implements OnInit {

  @Input() hidden = true;
  @Output() onBurgerClicked = new EventEmitter();

  CultureModel = CultureModel;
  CountryModel = CountryModel;

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  // onBurgerClicked
  onClicked() {
    this.hidden = !this.hidden;
    this.onBurgerClicked.emit();
  }

  navigateHome() {

    this.router.navigate(NavigationModel.getHomeURLPaths(['landing']));

  }

  navigateFeatures() {

    this.router.navigate(NavigationModel.getHomeURLPaths(['features', 'game']));

  }

  navigateSchools() {

    this.router.navigate(NavigationModel.getHomeURLPaths(['schools']));

  }

  navigatePricing() {

    this.router.navigate(NavigationModel.getHomeURLPaths(['pricing']));

  }

  login() {

    if (UserModel.isLoggedIn()) {

      if (UserModel.getCurrent().hasSchoolAccess() && SchoolModel.getCurrent() === null) {

        this.router.navigate(['selectschool']);

      } else {

        if (StudentModel.getCurrent()) {
          this.router.navigate(['platform', 'dash']);
        } else {
          this.router.navigate(['selectstudent']);
        }

      }

    } else {

      this.router.navigate(NavigationModel.getHomeURLPaths(['signin']));

    }

  }

  getStartedClicked() {

    if (UserModel.isLoggedIn()) {

      if (UserModel.getCurrent().hasSchoolAccess() && SchoolModel.getCurrent() === null) {

        this.router.navigate(['selectschool']);

      } else {

        if (StudentModel.getCurrent()) {
          this.router.navigate(['platform', 'dash']);
        } else {
          this.router.navigate(['selectstudent']);
        }

      }

    } else {

      this.router.navigate(NavigationModel.getHomeURLPaths(['signup']));

    }

  }

  navigateResearch() {

    this.router.navigate(NavigationModel.getHomeURLPaths(['research']));

  }

  getStartedButtonTitle(): string {

    if (UserModel.getCurrent()) {
      return 'header.dashboard';
    }

    return 'header.getStarted';
  }

  isUserLoggedIn(): boolean {

    if (UserModel.getCurrent()) {
      return true;
    }

    return false;
  }
}
